module.exports = __webpack_public_path__ + "static/media/search-input-cross.175e1d5b.svg";